export enum PackageManagerName {
  BUN = "bun",
  LOCAL_BUN = "local_bun",
  NPM = "npm",
  PNPM = "pnpm",
  YARN = "yarn",
}
